"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.heading02 = exports.heading01 = exports.bulletList01 = exports.bodyBold02 = exports.body02 = exports.bodyBold01 = exports.body01 = exports.labelBold01 = exports.label01 = void 0;
// @ts-check
const typography_1 = __importDefault(require("./typography"));
/**
 * @typedef { import("../../index").TypographySet } TypographySet
 */
// Letter Spacing
const letterSpacingLabel = 'normal';
const letterSpacingBody01 = '-0.006rem';
const letterSpacingBody02 = '-0.011rem';
const letterSpacingHeading01 = '-0.017rem';
const letterSpacingHeading02 = '-0.020rem';
// Line Height
const lineHeightLabel = '1rem';
const lineHeightBody01 = '1.25rem';
const lineHeightBody02 = '1.375rem';
const lineHeightBulletList01 = '1.5rem';
const lineHeightHeading01 = '1.75rem';
const lineHeightHeading02 = '2rem';
/** @type {TypographySet} */
exports.label01 = {
    fontFamily: typography_1.default.fontFamilyPrimary,
    fontSize: typography_1.default.fontSize4xs,
    lineHeight: lineHeightLabel,
    fontWeight: typography_1.default.fontWeightRegular,
    letterSpacing: letterSpacingLabel,
};
/** @type {TypographySet} */
exports.labelBold01 = {
    fontFamily: typography_1.default.fontFamilyPrimary,
    fontSize: typography_1.default.fontSize4xs,
    lineHeight: lineHeightLabel,
    fontWeight: typography_1.default.fontWeightSemiBold,
    letterSpacing: letterSpacingLabel,
};
/** @type {TypographySet} */
exports.body01 = {
    fontFamily: typography_1.default.fontFamilyPrimary,
    fontSize: typography_1.default.fontSize3xs,
    lineHeight: lineHeightBody01,
    fontWeight: typography_1.default.fontWeightRegular,
    letterSpacing: letterSpacingBody01,
};
/** @type {TypographySet} */
exports.bodyBold01 = {
    fontFamily: typography_1.default.fontFamilyPrimary,
    fontSize: typography_1.default.fontSize3xs,
    lineHeight: lineHeightBody01,
    fontWeight: typography_1.default.fontWeightSemiBold,
    letterSpacing: letterSpacingBody01,
};
/** @type {TypographySet} */
exports.body02 = {
    fontFamily: typography_1.default.fontFamilyPrimary,
    fontSize: typography_1.default.fontSize2xs,
    lineHeight: lineHeightBody02,
    fontWeight: typography_1.default.fontWeightRegular,
    letterSpacing: letterSpacingBody02,
};
/** @type {TypographySet} */
exports.bodyBold02 = {
    fontFamily: typography_1.default.fontFamilyPrimary,
    fontSize: typography_1.default.fontSize2xs,
    lineHeight: lineHeightBody02,
    fontWeight: typography_1.default.fontWeightSemiBold,
    letterSpacing: letterSpacingBody02,
};
/** @type {TypographySet} */
exports.bulletList01 = {
    fontFamily: typography_1.default.fontFamilyPrimary,
    fontSize: typography_1.default.fontSize3xs,
    lineHeight: lineHeightBulletList01,
    fontWeight: typography_1.default.fontWeightRegular,
    letterSpacing: letterSpacingBody01,
};
/** @type {TypographySet} */
exports.heading01 = {
    fontFamily: typography_1.default.fontFamilyPrimary,
    fontSize: typography_1.default.fontSizeSm,
    lineHeight: lineHeightHeading01,
    fontWeight: typography_1.default.fontWeightSemiBold,
    letterSpacing: letterSpacingHeading01,
};
/** @type {TypographySet} */
exports.heading02 = {
    fontFamily: typography_1.default.fontFamilyPrimary,
    fontSize: typography_1.default.fontSizeLg,
    lineHeight: lineHeightHeading02,
    fontWeight: typography_1.default.fontWeightSemiBold,
    letterSpacing: letterSpacingHeading02,
};
